import { create } from "zustand";

export type HermesToastTone = "success" | "error" | "info";

export type HermesToastData = {
  id: number;
  message: string;
  tone: HermesToastTone;
};

type HermesToastState = {
  toasts: HermesToastData[];
  show: (message: string, tone: HermesToastTone) => void;
  dismiss: (id: number) => void;
};

/** Quantos avisos cabem na tela; o mais antigo sai quando chega um novo além disso. */
const MAX_TOASTS = 4;

let nextId = 1;

/**
 * Fila de avisos do Hermes. Fica num store (e não num contexto) porque quem
 * dispara o aviso é a tela, que está *acima* do `HermesScreen` onde mora o
 * `HermesToaster` — um contexto não alcançaria.
 */
const useHermesToastStore = create<HermesToastState>(set => ({
  toasts: [],
  show: (message, tone) =>
    set(state => ({
      toasts: [...state.toasts, { id: nextId++, message, tone }].slice(
        -MAX_TOASTS
      ),
    })),
  dismiss: id =>
    set(state => ({ toasts: state.toasts.filter(toast => toast.id !== id) })),
}));

export const useHermesToasts = () => useHermesToastStore(state => state.toasts);
export const dismissHermesToast = (id: number) =>
  useHermesToastStore.getState().dismiss(id);

/** `showToast` estável entre renders: pode entrar em `useCallback`/`useMemo` sem recriá-los. */
export const useHermesToast = () => ({
  showToast: useHermesToastStore.getState().show,
});
